module.exports = __webpack_public_path__ + "static/media/IMG_8046.3ab113b3.jpg";